function ordersSettingsSelectButton() {
    let $button = $('.orders-settings__select-button');
    let activeClass = 'orders-settings__select-button--active';


    $button.on('click', function () {
        let $currentButton = $(this);

        console.log($currentButton);

        let $form = $currentButton.closest('.orders-settings__select-buttons');
        console.log($form);

        let $buttons = $form.find('.orders-settings__select-button');

        console.log($buttons);

        if (!$currentButton.hasClass(activeClass)) {
            $buttons.removeClass(activeClass);
            $currentButton.addClass(activeClass);
        }
    });


}

ordersSettingsSelectButton();
